const config = {
    // apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8080",
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://api.horizondatawave.ai",
    logoUrl: process.env.REACT_APP_LOGO_URL || "https://api.horizondatawave.ai/static/favicon.png",
    sentryDSN: process.env.REACT_APP_SENTRY_DSN || "https://547580f9a9694fdc9e18af3c44872968@o4508301490978816.ingest.de.sentry.io/4508794356564049",
    
    // Chat API endpoints
    chat: {
        sendMessage: "/chat/send",
        getHistory: "/chat/history", 
        getUserContext: "/chat/context",
        getSessions: "/chat/sessions"
    }
};

export default config;